import React, { useContext, useState } from 'react'
import './BeverageItem.css'
import { StoreContext } from '../context/StoreContext'
import { assets } from '../assets/assets';
import SetShowPopUp  from '../AddOn/AddOn'

export default function BevarageItem({id,name,image}) {

    const {cartItems,addToCart,removeFromCart,url} = useContext(StoreContext);
      
return (
  <>
  <div className='bev-item'>
      <div className='bev-item-img-container'>
          <img className='bev-item-image' src={url+"/images/"+image} alt="" />
        {!cartItems[id]
          ? <img className="add" onClick={() => addToCart(id)} src={assets.add_icon_white} alt="" />
          :<div className='foot-item-counter'>
            <img onClick={()=>removeFromCart(id)} src={assets.remove_icon_red} alt=''/>
            <p>{cartItems[id]}</p>
            <img onClick={()=>addToCart(id)} src={assets.add_icon_green} alt=''/>
          </div>
        }  
      </div>
      <div className='bev-item-info'>
          <div className='bev-item-name'>
              <p>{name}</p>
          </div>
      </div>
  </div>
  </>
)
}
